<template>
  <div class="container">
    <notifications></notifications>
    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
      <form @submit.prevent="login">
        <card class="card-login card-white">
          <template slot="header">
            <img
              src="img/card-primary.png"
              alt=""
            />
            <h1 class="card-title">Log in</h1>
          </template>
          <div>
            <base-input
              v-validate="'required|email'"
              name="email"
              :error="getError('email')"
              v-model="model.email"
              placeholder="Email"
              addon-left-icon="tim-icons icon-email-85"
            >
            </base-input>
            <base-input
              v-validate="'required|min:5'"
              name="password"
              :error="getError('password')"
              v-model="model.password"
              type="password"
              placeholder="Password"
              addon-left-icon="tim-icons icon-lock-circle"
            >
            </base-input>
          </div>
          <div slot="footer">
            <base-button
              native-type="submit"
              type="primary"
              class="mb-3"
              size="lg"
              block
            >
              Login
            </base-button>
            <div class="pull-left">
              <h6>
                <router-link
                  class="link footer-link"
                  to="/register"
                >
                  Create Account
                </router-link>
              </h6>
            </div>

            <div class="pull-right">
              <h6><a
                  href="#"
                  class="link footer-link"
                  @click.prevent="passwordReset"
                >Forgot your password?</a></h6>
            </div>
          </div>
        </card>
      </form>
    </div>
  </div>
</template>
<script>
import { auth, db } from '@/util/firebase.js'
import { notifySuccess, notifyDanger } from '@/util/defaultNotifications.js'
export default {
  data() {
    return {
      model: {
        email: '',
        password: '',
      },
    }
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    async login() {
      let isValidForm = await this.$validator.validateAll()
      if (isValidForm) {
        try {
          const { email, password, passwordVerify } = this.model
          const response = await auth.signInWithEmailAndPassword(email, password)
          const { emailVerified, uid } = response.user

          if (emailVerified) {
            try {
              const response = await db
                .collection('userMetadata')
                .doc(uid)
                .get()

              if (response.exists) {
                const { subscriptionType, userGroup } = response.data()
                this.$store.commit('SET_INITIAL_USER_INFO', {
                  email,
                  uid,
                  emailVerified: true,
                  subscriptionType,
                  userGroup,
                })
                this.$router.push('dashboard')
              }
            } catch (error) {
              console.log(error)
            }
          } else {
            notifyDanger('Please verify your email')
            this.$router.push('verification')
          }
        } catch (e) {
          notifyDanger('Error while logging in. Please check your credentials!')
          console.log('e :', e)
        }
      }
    },
    async passwordReset() {
      const isValid = await this.$validator.validate('email')
      if (isValid) {
        try {
          await auth.sendPasswordResetEmail(this.model.email)
          notifySuccess('Password reset email has been sent.')
        } catch (error) {
          notifyDanger('An error occured.')
        }
      }
    },
  },
}
</script>
